import {DEFAULT_HOST, routeTo} from '@/utils/router'

import {FaqCategoryName, getFAQsContent} from '../FAQs'

export const getBrandMonitoringGuideContent = () => ({
  metaTitle: 'brand-monitoring.guide-meta-title',
  metaDescription: 'brand-monitoring.guide-meta-desc',
  ogImage: {
    url: `${DEFAULT_HOST}/images/og-images/brand-protection-guide-en.png`,
    width: 1200,
    height: 627,
    alt: 'Brand protection guide - OG image',
  },
  hero: {
    title: 'brand-monitoring.guide-hero-title',
    subtitle: 'brand-monitoring.guide-hero-subtitle',
  },
  platformList: {
    title: 'brand-monitoring.guide-platforms-title',
    description: 'brand-monitoring.guide-platforms-desc',
  },
  otherPlatformsTitle: 'brand-monitoring.guide-other-platforms-title',
  learnMoreText: 'learn-more-text',
  contentsTitle: 'contents-title',
  registrationCard: {
    title: 'brand-monitoring.guide-registration-card-title',
    description: 'brand-monitoring.guide-registration-card-desc',
    imageSrc: '/images/icons/r-sign-with-stamp.svg',
    imageAlt: 'R sign with a stamp',
  },
  getStartedBanner: {
    title: 'get-started-banner-title',
    primaryButtonLink: routeTo.brandMonitoring.order(),
    primaryButtonText: 'brand-monitoring.guide-start-monitoring-title',
  },
  helpCenterCategories: getFAQsContent(FaqCategoryName.brandProtection).categories,
})
